export enum CheckSources {
	On = 1,
	OnlineOrder = 2,
	POS = 3,
	MobilePay = 4,
	HUB = 5,
	Subscription = 6,
	Kiosk = 7,
}
